import axiosHttp from "services/axiosHttp";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchRewardOrderInvoiceInfo = createAsyncThunk("fetchRewardOrderInvoiceInfo", async ({ id }) => {
	const response = await axiosHttp.get(`invoice/${id}`);
	return response.data.data;
});

const RewardOrderInvoiceInfoSlice = createSlice({
	name: "RewardOrderInvoiceInfoSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
	},

	extraReducers: (builder) => {
		builder.addCase(fetchRewardOrderInvoiceInfo.pending, (state) => {
			state.isLoading = true;
		});

		builder.addCase(fetchRewardOrderInvoiceInfo.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
		});
		builder.addCase(fetchRewardOrderInvoiceInfo.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export default RewardOrderInvoiceInfoSlice.reducer;
